export default __webpack_public_path__ + "static/media/view4_week_province_place_cause_.7a80d208.csv";